"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconInsurance = function IconInsurance(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m12 21.95-.672-.375c-3.386-1.905-5.377-5.016-6.498-8.05-1.119-3.028-1.402-5.062-1.315-6.967l.042-.931h.932c3.586 0 5.922-1.801 6.568-2.576C11.294 2.766 12 2 12 2s.706.766.943 1.051c.646.775 2.982 2.576 6.568 2.576h.932l.042.931c.087 1.905-.196 3.94-1.315 6.968-1.12 3.033-3.112 6.144-6.498 8.049zm0-17.078C10.819 5.942 8.554 7.3 5.455 7.54c.035 1.675.351 2.996 1.205 5.309.984 2.662 2.65 5.237 5.34 6.858 2.69-1.62 4.356-4.196 5.34-6.858.854-2.313 1.17-3.634 1.206-5.31-3.1-.24-5.365-1.597-6.546-2.668",
    clipRule: "evenodd"
  })));
};

export { IconInsurance, IconInsurance as default };
